import React from "react";
import {CircularProgress} from "@mui/material";
import {Box} from "@mui/system";
import {Search, ErrorOutline} from "@mui/icons-material";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";
import {ErrorBlock} from "~/components/ErrorBlocks/ErrorBlock";
import {Loader} from "~/ui/icons";


export type LoadingResultProps = {
    loading?: boolean
    error?: boolean
    empty?: boolean
    errorText?: string
    emptyText?: string
    placeholder?: any
    className?: string
    isInitialLoading?: boolean
}


const useStyles = makeStyles<PortTheme, LoadingResultProps>(theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        //justifyContent: "center",
        flexWrap: "nowrap",
        "& > *": {
            marginBottom: "20px",
            "&:last-child": {
                marginBottom: 0,
            }
        }
    },
    searchIcon: {
        color: `${theme.palette.additionalSecondary.main}!important`,
        width: 32,
        height: 32
    },
    loadingBox: {
        padding: '8px 16px 0',
    },
    loadingBoxInitial: {
        padding: "140px 25px 25px",
        flexGrow: 1,
        "@media (max-height: 640px)": {
            paddingTop: "60px",
        }
    },
    loadingIconInitial: {
        width: '56px',
        height: '56px',
        animation: "$spin 1s linear infinite",
    },
    loadingIcon: {
        width: '32px',
        height: '32px',
        animation: "$spin 1s linear infinite",
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)",
        },
        "100%": {
            transform: "rotate(360deg)",
        },
    },
}))


export const LoadingResult = (props: LoadingResultProps) => {
    const {emptyText, errorText, loading, error, empty, placeholder, className, isInitialLoading = true} = props;
    const classes = useStyles(props);
    let content = null;

    if (loading) {
        content = (
            <Box className={isInitialLoading ? classes.loadingBoxInitial : classes.loadingBox}>
                <Loader className={isInitialLoading ? classes.loadingIconInitial : classes.loadingIcon} />
            </Box>
        )
    } else if (error) {
        content = (
            <ErrorBlock icon={<ErrorOutline/>}>
                {errorText || "Ошибка загрузки"}
            </ErrorBlock>
        )
    } else if (empty) {
        content = (
            <ErrorBlock icon={<Search className={classes.searchIcon}/>} title={emptyText || "По вашему запросу ничего не найдено"}/>
        )
    } else if (placeholder) {
        content = <Box height={42}/>;
    }

    if (!content) {
        return null;
    }

    return (
        <div className={[classes.root, className].join(" ")}>
            {content}
        </div>
    )
}
